import React from 'react';
import './CommonButton.css';

const CommonButton = ({
  children,
  variant = "primary",
  size = "medium",
  type = "button",
  disabled = false,
  loading = false,
  fullWidth = false,
  className = "",
  onClick,
  icon,
  iconPosition = "left",
  ...props
}) => {
  const buttonClasses = [
    "common-button",
    `common-button--${variant}`,
    `common-button--${size}`,
    fullWidth && "common-button--full-width",
    disabled && "common-button--disabled",
    loading && "common-button--loading",
    className
  ].filter(Boolean).join(" ");

  const handleClick = (e) => {
    if (!disabled && !loading && onClick) {
      onClick(e);
    }
  };

  const renderIcon = () => {
    if (!icon) return null;
    
    const iconElement = typeof icon === 'string' ? (
      <span className="button-icon-text">{icon}</span>
    ) : icon;

    return (
      <span className={`button-icon button-icon--${iconPosition}`}>
        {iconElement}
      </span>
    );
  };

  const renderContent = () => {
    if (loading) {
      return (
        <>
          <span className="button-spinner"></span>
          <span className="button-loading-text">Loading...</span>
        </>
      );
    }

    if (icon && iconPosition === "left") {
      return (
        <>
          {renderIcon()}
          <span className="button-text">{children}</span>
        </>
      );
    }

    if (icon && iconPosition === "right") {
      return (
        <>
          <span className="button-text">{children}</span>
          {renderIcon()}
        </>
      );
    }

    return <span className="button-text">{children}</span>;
  };

  return (
    <button
      type={type}
      className={buttonClasses}
      disabled={disabled || loading}
      onClick={handleClick}
      {...props}
    >
      {renderContent()}
    </button>
  );
};

export default CommonButton; 